import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#a91233',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        forestTeal: '#005952',
        reliableblue: '#1256a9',
      },
    },
  },
})

export default new Vuetify({
});
